import { US_STATE_COORDINATES, DEFAULT_STATE_ZOOM, US_CENTER_COORDINATES, US_CENTER_ZOOM } from '_constants';

export const getStateCoordinates = (stateName) => {
  if (!stateName || typeof stateName !== 'string') {
    return {
      coordinates: US_CENTER_COORDINATES,
      zoom: US_CENTER_ZOOM,
      isStateLevel: false,
    };
  }

  const normalizedStateName = stateName.trim();
  const stateCoords = US_STATE_COORDINATES[normalizedStateName];

  if (stateCoords) {
    return {
      coordinates: stateCoords,
      zoom: DEFAULT_STATE_ZOOM,
      isStateLevel: true,
    };
  }

  return {
    coordinates: US_CENTER_COORDINATES,
    zoom: US_CENTER_ZOOM,
    isStateLevel: false,
  };
};

export const hasValidStateCoordinates = (stateName) => {
  if (!stateName || typeof stateName !== 'string') {
    return false;
  }
  return Object.hasOwn(US_STATE_COORDINATES, stateName.trim());
};
